import {
  type BiddingIntradayOrderWithdrawFailureReason,
  BiddingIntradayOrderWithdrawState,
} from '@ebalance/proto/bffuser/v1/bidding_intraday_model_pb'
import { useTranslation } from 'react-i18next'

import { Badge } from '@enechain/ecloud-designsystem'

import { withdrawFailureTextKeys } from '~/pages/IntradayBidding/models/withdrawFailureText'

/**
 * 板取消の進行状態 (AC-BIN-008b) を、 ステータスバッジとは別軸のチップで併記する。
 * ステータス (入札中 / 部分約定 / 全約定 など) は札の実際の状態なので書き換えない。
 * 取消処理中 (PENDING) は warning、 失敗確定 (FAILED) は「取消失敗」 を negative で出す
 * (取消を頼んだのに通っていない = 利用者の意図と違う状態が続いている)。 失敗確定は
 * トーストを見ていなくても、 画面を閉じた・再読込した後でも分かるよう、 取消し直すか
 * 札が消えるまで残す。 取消要求なし (UNSPECIFIED) は何も出さない。
 */
export const BiddingIntradayWithdrawStateTag = ({
  state,
  failureReason,
}: {
  state: BiddingIntradayOrderWithdrawState | undefined
  failureReason: BiddingIntradayOrderWithdrawFailureReason | undefined
}): React.ReactElement | null => {
  const { t } = useTranslation()
  if (state === BiddingIntradayOrderWithdrawState.PENDING) {
    return (
      <Badge
        data-testid="withdraw-state-chip"
        status="warning"
        title={t('page:biddingIntraday.withdrawState.pendingHint')}
      >
        {t('page:biddingIntraday.withdrawState.pending')}
      </Badge>
    )
  }
  if (state === BiddingIntradayOrderWithdrawState.FAILED) {
    return (
      <Badge
        data-testid="withdraw-failed-chip"
        status="negative"
        title={t(withdrawFailureTextKeys(failureReason).hint)}
      >
        {t('page:biddingIntraday.withdrawState.failed')}
      </Badge>
    )
  }
  return null
}
